import script from "./Quote.vue?vue&type=script&setup=true&lang=js"
export * from "./Quote.vue?vue&type=script&setup=true&lang=js"

import "./Quote.vue?vue&type=style&index=0&id=59b0b2f6&lang=scss"

const __exports__ = script;

export default __exports__